import React from 'react';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Link, useLocation, useParams } from 'react-router-dom';
import styles from './SideBarMenu.module.css';
import { getImage } from '../../Services/Utils/FileApis';

export default function SideBarMenu(props) {
  const user = useSelector((state) => state.user);
  const param = useParams();
  const location = useLocation();
  const { categoryData } = props;

  return (
    <Box className={`${styles['menu-wrapper']}`} sx={{ display: 'flex' }}>
      <div className={`${styles['side-bar-menu-ul']} ${styles['open-drawer']}`}>
        <div className={`${styles['side-bar-bg']}`}>
          {user?.view.roleView.id !== 1 ? (
            categoryData.length > 0
            && categoryData.map((res, key) => (
              <List key={key}>
                <ListItem className={param.id === (res.id ? (res.id).toString() : null) ? `${styles.active}` : ''}>
                  <Link to={`/category/${res.id}/${res.id}`}>
                    <ListItemButton className={`${styles['button-base']}`}>
                      <ListItemIcon className={`${styles['menu-icon']}`}>
                        <img src={`${getImage(res.bannerFileView)}`} width="30" alt="ctg" />
                      </ListItemIcon>
                      <ListItemText className={`${styles['menu-text']}`}>
                        {res.name}
                      </ListItemText>
                    </ListItemButton>
                  </Link>
                </ListItem>
              </List>
            ))
          ) : (
            <List>
              <ListItem className={location.pathname.includes('startups') ? `${styles.active}` : ''}>
                <Link to="/startups">
                  <ListItemButton className={`${styles['button-base']}`}>
                    <ListItemIcon className={`${styles['menu-icon']}`}>
                      <img src="/assets/images/start-up.svg" alt="ctg" />
                    </ListItemIcon>
                    <ListItemText className={`${styles['menu-text']}`}>
                      Startups
                    </ListItemText>
                  </ListItemButton>
                </Link>
              </ListItem>
              <ListItem className={location.pathname.includes('plan') ? `${styles.active}` : ''}>
                <Link to="/plans">
                  <ListItemButton className={`${styles['button-base']}`}>
                    <ListItemIcon className={`${styles['menu-icon']}`}>
                      <img src="/assets/images/plans.svg" alt="" />
                    </ListItemIcon>
                    <ListItemText className={`${styles['menu-text']}`}>
                      Plans
                    </ListItemText>
                  </ListItemButton>
                </Link>
              </ListItem>
              <ListItem className={location.pathname.includes('categories') ? `${styles.active}` : ''}>
                <Link to="/categories">
                  <ListItemButton className={`${styles['button-base']}`}>
                    <ListItemIcon className={`${styles['menu-icon']}`}>
                      <img src="/assets/images/categories.svg" alt="" />
                    </ListItemIcon>
                    <ListItemText className={`${styles['menu-text']}`}>
                      Categories
                    </ListItemText>
                  </ListItemButton>
                </Link>
              </ListItem>
              <ListItem className={location.pathname.includes('service-provider') ? `${styles.active}` : ''}>
                <Link to="/service-provider-master">
                  <ListItemButton className={`${styles['button-base']}`}>
                    <ListItemIcon className={`${styles['menu-icon']}`}>
                      <img src="/assets/images/service-provider.svg" alt="" />
                    </ListItemIcon>
                    <ListItemText className={`${styles['menu-text']}`}>
                      Service Partners
                    </ListItemText>
                  </ListItemButton>
                </Link>
              </ListItem>
              <ListItem className={location.pathname.includes('notification') ? `${styles.active}` : ''}>
                <Link to="/notifications">
                  <ListItemButton className={`${styles['button-base']}`}>
                    <ListItemIcon className={`${styles['menu-icon']}`}>
                      <img src="/assets/images/notifications.svg" alt="" />
                    </ListItemIcon>
                    <ListItemText className={`${styles['menu-text']}`}>
                      Notifications
                    </ListItemText>
                  </ListItemButton>
                </Link>
              </ListItem>
              <ListItem className={location.pathname.includes('mis') ? `${styles.active}` : ''}>
                <Link to="/mis">
                  <ListItemButton className={`${styles['button-base']}`}>
                    <ListItemIcon className={`${styles['menu-icon']}`}>
                      <img src="/assets/images/mis.svg" alt="" />
                    </ListItemIcon>
                    <ListItemText className={`${styles['menu-text']}`}>
                      MIS
                    </ListItemText>
                  </ListItemButton>
                </Link>
              </ListItem>
              <ListItem className={location.pathname.includes('email-content') ? `${styles.active}` : ''}>
                <Link to="/email-contents">
                  <ListItemButton className={`${styles['button-base']}`}>
                    <ListItemIcon className={`${styles['menu-icon']}`}>
                      <img src="/assets/images/email-contents.svg" alt="" />
                    </ListItemIcon>
                    <ListItemText className={`${styles['menu-text']}`}>
                      Email Contents
                    </ListItemText>
                  </ListItemButton>
                </Link>
              </ListItem>
              <ListItem className={location.pathname.includes('data-repository') ? `${styles.active}` : ''}>
                <Link to="/data-repository">
                  <ListItemButton className={`${styles['button-base']}`}>
                    <ListItemIcon className={`${styles['menu-icon']}`}>
                      <img src="/assets/images/email-contents.svg" alt="" />
                    </ListItemIcon>
                    <ListItemText className={`${styles['menu-text']}`}>
                      Data Repository
                    </ListItemText>
                  </ListItemButton>
                </Link>
              </ListItem>
              <ListItem className={location.pathname.includes('support') ? `${styles.active}` : ''}>
                <Link to="/support-list">
                  <ListItemButton className={`${styles['button-base']}`}>
                    <ListItemIcon className={`${styles['menu-icon']}`}>
                      <img src="/assets/images/email-contents.svg" alt="" />
                    </ListItemIcon>
                    <ListItemText className={`${styles['menu-text']}`}>
                      Support
                    </ListItemText>
                  </ListItemButton>
                </Link>
              </ListItem>
            </List>
          )}
          <Divider />
        </div>
      </div>
    </Box>
  );
}
